<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <div class="sc-option" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="show = true">
                <div class="sc-option-content">
                    {{ activeName }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="show"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelect(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'transmissionType',
                keyName: '变速箱',
                show: false,
                activeName: formBean.transmissionTypeName || '请选择变速箱',
                list: [{
                    value: 1,
                    name: '手动'
                }, {
                    value: 2,
                    name: '自动'
                }, {
                    value: false,
                    name: '不限'
                }]
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.show = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavTransmission.vue?7f948854